import { render, staticRenderFns } from "./PackageItem.vue?vue&type=template&id=1ff1e7ce"
import script from "./PackageItem.vue?vue&type=script&lang=js"
export * from "./PackageItem.vue?vue&type=script&lang=js"
import style0 from "./PackageItem.vue?vue&type=style&index=0&id=1ff1e7ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports